import wixData from 'wix-data'
import { session } from 'wix-storage'
import { rendering } from 'wix-window'
import wixLocation from 'wix-location'
import wixSeo from 'wix-seo'

import { pageApp } from 'public/Factor/pageApp' // '@noamsi/factorblocks2'
import { getSubjects, subjectsToOptions, flattenCourses, sortCourses, slideElementWithHeader } from 'public/utils'
import { sendBi } from 'public/biModule'
import { timed } from 'public/Logger/timedLogger'

function mapData2UiState({ coursesFlattened, subjectsAsOptions }) {
    return {
        '#courses': {
            paths: {
                'courses': coursesFlattened
            }
        },
        '#sortDropdown': {
            paths: {
                'value': 'mostPopular'
            }
        },
        '#subjects': {
            paths: {
                'subjects': subjectsAsOptions,
                'selectedSubjects': []
            }
        },
    }
}

const eventHandles = {
    '#subjects': {
        'onChange': (pageApp, [event]) => {
            updateCourses()
            wixLocation.to(`/${wixLocation.path[0]}`)
        }
    },
    '#sortDropdown': {
        onChange: (pageApp, [event]) => {
            const { id, value } = event.target
            pageApp.setState(`#${id}.paths.value`, value)
            updateCourses()
        }
    }
}

$w.onReady(async function () {
    await timed('Courses Page', async () => {
        const [subjects, courses] = await Promise.all([getPageSubjects(), getCourses()])

        const subjectsAsOptions = subjectsToOptions(subjects)
        const coursesFlattened = flattenCourses(courses)

        pageApp.start({ coursesFlattened, subjectsAsOptions, subjects }, mapData2UiState, eventHandles)

        handlePreSelectedSubject(subjects, wixLocation.path[1])

        if (rendering.env === 'browser') {
            // slideElementWithHeader('#subjectsMenuSection')

            sendBi('pageOpen', {
                'sourcePage': session.getItem('previousPageName'),
                'name': session.getItem('currentPageName')
            })
        }
    }, { renderingEnv: rendering.env })
})

const getCourses = async () => {
    const { items: courses } = await wixData.query('Courses')
        .ne('unlisted', true)
        .descending('views')
        .include('subject', 'classes')
        .find()

    return courses
}

const handlePreSelectedSubject = (subjects, initialSubjectSlug) => {
    if (!initialSubjectSlug) return

    const subjectBySlug = subjects.find(subject => (subject.slug === initialSubjectSlug))
    pageApp.setState({ '#subjects.paths.selectedSubjects': [subjectBySlug._id] })
    updateCourses()

    setSubjectSeoTitleAndDescription(subjectBySlug)
}

const setSubjectSeoTitleAndDescription = (subject) => {
    const skillsFor = (subject.isNoun) ? 'skills for ' : ''
    const title = `Learn ${skillsFor}${subject.title} | Free Online Courses | Wix Learn`
    const description = `Get quick, hands-on guidance and deep dive into ${skillsFor}${subject.title} courses created by Wix Learn just for you!`

    wixSeo.setMetaTags([
        ...wixSeo.metaTags,
        { 'property': 'og:title', 'content': title },
        { 'property': 'og:description', 'content': description },
        { 'name': 'description', 'content': description }
    ])

    wixSeo.setTitle(title)
}

const getPageSubjects = async () => {
    const subjects = await getSubjects()
    return subjects.filter(subject => (subject.hasCourses))
}

function updateCourses() {
    const coursesFlattened = pageApp.getData().coursesFlattened

    const selectedSubjects = $w('#subjects').getSelectedSubjects()

    updateH1(selectedSubjects)

    const filtererdCourses = filterCourses(coursesFlattened, selectedSubjects)

    const filtererdSortedCourses = sortCourses(filtererdCourses, $w('#sortDropdown').value)

    pageApp.setState('#courses.paths.courses', filtererdSortedCourses)
}

const updateH1 = (selectedSubjects) => {
    if (selectedSubjects.length === 1) {
        const selectedSubjectId = selectedSubjects[0]
        const { subjects } = pageApp.getData()
        const selectedSubject = subjects.find(subject => (subject._id === selectedSubjectId))
        $w('#pageTitle').text = `${selectedSubject.title} *courses`
        $w('#pageTitle').html = `<h1 class="font_2"><span>${selectedSubject.title} <span style="color:#166AEA">*</span>Courses</span></h1>`
        $w('#pageSubTitle').text = `Take a full online course or skip around to the lessons that interest you most to gain in-depth knowledge and learn best practices for ${selectedSubject.title}`
    } else {
        $w('#pageTitle').text = 'Online Courses'
    }
}

function filterCourses(courses, selectedSubjectIds) {
    return (selectedSubjectIds.length === 0) ?
        courses :
        courses.filter(course => selectedSubjectIds.includes(course.subjectId))
}